import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Header from "../common/Header";
import NotificationBar from "../Parts/NotificationBar.jsx";
import TabsControlSection from "./sections/TabsControlSection";
import ResultHeaderSection from "./sections/ResultHeaderSection";
import ResultEmptySection from "./sections/ResultEmptySection";
import ResultSection from "./sections/ResultSection";
import ResultLoaderSection from "./sections/ResultLoaderSection";
import { OwnerType } from '../../constants/ComponentTypes';
import { ORDER_PER_PAGE } from "../../constants/Constants";
import moment from 'moment';
const { Set } = require("immutable");

const styles = () => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
  },

  main: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
  },

  content: {
    width: "100%",
    boxSizing: "border-box",
    paddingTop: 40,
    overflowY: 'auto',
  },

  notificationContainer: {
    position: "fixed",
    zIndex: 10000,
    top: 10,
    width: "98%",
    left: "1%",
  },
});

class OrderList extends React.Component {
  initialState = {
    ownerType: OwnerType.OWN.value,
    message: "",
    messageType: "success",
    showNotification: false,
    isPageLoaded: false,
    selectedItems: Set(),
    selectedYear: "",
    selectedMonth: "",
  };

  constructor(props) {
    super(props);
    const ownType = props.location.state && props.location.state.ownerType ? props.location.state.ownerType : OwnerType.OWN.value;
    const selectedYear = props.location.state && props.location.state.selectedYear ? props.location.state.selectedYear : moment().format('YYYY');
    const selectedMonth = props.location.state && props.location.state.selectedMonth ? props.location.state.selectedMonth : moment().format('M');
    this.state = { ...this.initialState, ...{ ownerType: ownType, selectedYear: selectedYear, selectedMonth: selectedMonth } };
  }

  componentDidMount() {
    this.props.initializeMessage();
    this.props.getUserInfo();
    this.props.getSalesforceConfig();
    this.getOrderList();
    this.getCurrentMouthOrdersOverview();
    if (this.formatSelectedYearMonth() !== moment().format('YYYY-M')) {
      this.getSelectYearMonthOrdersOverview();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isLoading) {
      document.body.style.cursor = "progress";
    } else {
      document.body.style.cursor = "auto";
    }

    if (nextProps.message && nextProps.message !== "") {
      this.displayNotification(nextProps.message, "success");
    } else if (nextProps.errorMessage && nextProps.errorMessage !== "") {
      this.displayNotification(nextProps.errorMessage, "error");
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.isPostingSalesforceSync === true &&
      !this.props.isPostingSalesforceSync
    ) {
      this.getOrderList({ page: this.props.pageInfo.current_page });
    }

    // ジョブ実行後でリロードされた場合を考慮し、ユーザー情報が取得でき次第、接続・再接続する
    if (this.props.user && !prevProps.user) {
      this.props.jobCompleted(this.props.user.id);
    }
  }

  getCurrentMouthOrdersOverview = () => {
    this.props.getCurrentMouthOrdersOverview({
      is_own: this.state.ownerType === OwnerType.OWN.value ? 'true' : 'false',
    });
  };

  getSelectYearMonthOrdersOverview = () => {
    const selectedYearMonth = moment(this.formatSelectedYearMonth(), 'YYYY-M');
    this.props.getSelectYearMonthOrdersOverview({
      is_own: this.state.ownerType === OwnerType.OWN.value ? 'true' : 'false',
      'created_at_from': selectedYearMonth.startOf('month').format('YYYY-MM-DD'),
      'created_at_to': selectedYearMonth.endOf('month').format('YYYY-MM-DD'),
    });
  };

  getOrderList = (data = {}) => {
    let query = {
      is_own: this.state.ownerType === OwnerType.OWN.value ? 'true' : 'false',
      order_year_month: this.formatSelectedYearMonth(),
      paging: 1,
      per_page: ORDER_PER_PAGE,
      page: 1,
    }
    this.props.getOrderList({ ...query, ...data });
  };

  formatSelectedYearMonth = () => {
    return this.state.selectedYear + '-' + this.state.selectedMonth;
  };

  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  handleOwnerTypeChange = (value) => {
    this.setState({
      ownerType: value,
    }, () => {
      this.getCurrentMouthOrdersOverview();
      this.getSelectYearMonthOrdersOverview();
      this.getOrderList();
    });
  }

  handleSelectedYearChange = (value) => {
    const { user } = this.props;
    const currentDate = moment();
    const changeYearMonth = moment(value + '-' + this.state.selectedMonth, 'YYYY-M');
    let state = {
      selectedYear: value,
    };

    if (changeYearMonth.isAfter(currentDate, 'month')) {
      // 年の選択値を変更することで選択している月が現在の月より後であれば、現在の月を設定
      state.selectedMonth = currentDate.format('M');
    } else if (user) {
      const userCreatedAt = moment(user.created_at, 'YYYY-M');
      if (changeYearMonth.isBefore(userCreatedAt, 'month')) {
        // 年の選択値を変更することで選択された月が登録日より前であれば、登録日の月を設定
        state.selectedMonth = userCreatedAt.format('M');
      }
    }

    this.setState(state, () => {
      this.getSelectYearMonthOrdersOverview();
      this.getOrderList();
    });
  }

  handleSelectedMonthChange = (value) => {
    this.setState({
      selectedMonth: value,
    }, () => {
      this.getSelectYearMonthOrdersOverview();
      this.getOrderList();
    });
  }

  renderNotification = () => {
    const { classes } = this.props;
    if (this.state.showNotification) {
      return (
        <div className={classes.notificationContainer}>
          <NotificationBar
            message={this.state.message}
            type={this.state.messageType}
            open={this.state.showNotification}
            onHandleClose={() => {
              this.setState({ showNotification: false });
            }}
            autoClose={false}
            style={{
              width: this.state.messageType === "green" ? "fit-content" : "100%",
            }}
          ></NotificationBar>
        </div>
      );
    }
  }

  render() {
    const { classes, orderList, isLoading, pageInfo } = this.props;

    return (
      <div className={classes.root}>
        <Header title="注文履歴" type="dark" hasBackBtn={false} />

        <div className={classes.main}>
          <TabsControlSection
            ownerType={this.state.ownerType}
            handleOwnerTypeChange={this.handleOwnerTypeChange}
          />

          <ResultHeaderSection
            selectedYear={this.state.selectedYear}
            selectedMonth={this.state.selectedMonth}
            selectedYearMonth={this.formatSelectedYearMonth()}
            currentMonthOrdersOverview={this.props.currentMonthOrdersOverview}
            isLoadingCurrentMonthOrdersOverview={this.props.isLoadingCurrentMonthOrdersOverview}
            selectYearMonthOrdersOverview={this.props.selectYearMonthOrdersOverview}
            isLoadingSelectedYearMonthOverview={this.props.isLoadingSelectedYearMonthOverview}
            handleSelectedYearChange={this.handleSelectedYearChange}
            handleSelectedMonthChange={this.handleSelectedMonthChange}
            isLoading={isLoading}
          />
          <div className={classes.content}>
            {(() => {
              if (isLoading) {
                return <ResultLoaderSection />;
              } else if (orderList.size === 0) {
                return <ResultEmptySection goTo={this.props.goTo} />;
              } else {
                return <ResultSection
                  orders={orderList}
                  pageInfo={pageInfo}
                  getOrderList={this.getOrderList}
                  goTo={this.props.goTo}
                  isLoading={isLoading}
                  selectedYear={this.state.selectedYear}
                  selectedMonth={this.state.selectedMonth}
                  ownerType={this.state.ownerType}
                  displayNotification={this.displayNotification}
                />
              }
            })()}
            {this.renderNotification()}
          </div>
        </div>
      </div>
    );
  }
}

OrderList.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  orderList: PropTypes.object,
  pageInfo: PropTypes.object,
  isLoading: PropTypes.bool,
  isPostingSalesforceSync: PropTypes.bool,
  currentMonthOrdersOverview: PropTypes.object,
  isLoadingCurrentMonthOrdersOverview: PropTypes.bool,
  selectYearMonthOrdersOverview: PropTypes.object,
  isLoadingSelectYearMonthOrdersOverview: PropTypes.bool,
  getOrderList: PropTypes.func.isRequired,
  initializeMessage: PropTypes.func.isRequired,
  jobCompleted: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  getSalesforceConfig: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  getCurrentMouthOrdersOverview: PropTypes.func.isRequired,
  getSelectYearMonthOrdersOverview: PropTypes.func.isRequired,
  location: PropTypes.object,
  message: PropTypes.string,
  errorMessage: PropTypes.string,
  isLoadingSelectedYearMonthOverview: PropTypes.bool,
};

export default withStyles(styles)(OrderList);



// WEBPACK FOOTER //
// ./src/components/OrderList/OrderList.jsx